import apiClient from 'api-client';

export default (...args) => {
	return apiClient.get(...args);
};
